<template>
	<div class="frontend-style frontend-home-style">
	<div class="banner" >
		<div class="fixBg">
			<div class="bgWrapper">
				<div class="bgContent" :style="{backgroundImage:'url('+Images.Home.banner.bg+')'}"></div>
			</div>
		</div>
		<div class="filter"></div>
		<div class="textBox">
			<h1 v-html="$t('home.title')"/>
			<!-- <h5>{{$t('home.subTitle')}}</h5> -->
		</div>
		<Search
		v-if="CataNowList"
		@searching="getKeyword"
		@searchSwitch="searchSwitch"
		>
			<template v-slot:homeList>
				<div v-for="item in searchResult" @click="goPage('/products',{name:item[locales],cateId:item.cateId,id:item.id,pop:true})">
					<div>
						<img :src="cataIcon[item.cateId].iconPath" alt="">
					</div>
					<h4>{{item[locales]}}</h4>
					<p>{{item.size}}</p>
				</div>
				<div class="bottomBase" v-if="searchText"></div>
			</template>
		</Search>
	</div>
	<WireCoating/>
	<Exhibition
	v-if="News"
	:newsLength="News.length"
	/>
	<div class="about">
		<div class="filter">
			<div class="filterWrapper">
				<div class="filterBg" :style="{backgroundImage:'url('+Images.Home.about.bg+')'}"></div>
			</div>
			
		</div>
		<h2>{{$t('home.about.title')}}</h2>

		<VideoPlayer
			:pop="Video_pop"
		/>

		<h3>{{$t('About.title')}}</h3>
		<div class="split"></div>
		<p>{{$t('About.copy')}}</p>
		<ul>
			<li v-for="img in Images.Quality.cf">
				<img :src="img" alt="">
			</li>
		</ul>
		<div @click="goPage('/manufacture',null)" class="goManu cursorPoint">
			<h4>{{$t('home.about.button')}}</h4>
			<img :src="Images.Home.about.arrow" alt="">
		</div>
	</div>
	<VideoPlayer
		:pop="Videos.length"
		v-if="Video_pop"
		@Close="closeVideo"
	/>
	</div>
</template>

<script>
	import i18n from '../i18n'
	import { mapState , mapActions , mapGetters } from 'vuex'
	import VideoPlayer from '@/components/frontend/Videoplayer.vue'
	export default {
		name:"home",
		components:{
			VideoPlayer
		},
		data(){
			return{
				Banner:[
				{
					title:'Competitive, Efficient and the Best Quality',
				},
				{
					title:'Exporting best fastner globlly',
				},
				{
					title:'Best only, no normal',
				}],
				searchText:null,
				searchCategory:'McCwG9uaNqQIIY5HqlgL',
				Video_pop:true
			}
		},
		mounted () {
			this.Video_pop = localStorage.sp_video=='YES' || !this.Videos.length?false:true
			console.log(localStorage.sp_video)
		},
		computed: {
			...mapState('frontend',[
				'Images',
				'categories',
				'locales',
				'categoryNow',
				'products',
				'News',
				'Videos'
				]),
			...mapGetters('frontend',[
				'CataNowList'
			]),
			cataIcon(){
				if(this.categories){
					return this.categories.reduce((ac,el)=>{
						return {...ac,[el.id]:{...el.name}}
					},{})
					// 最後這個花括號是累加器的初始值
				}
			},
			searchResult(){
				if(this.searchText){
						const newArr = this.products.filter(item=>{
							return this.searchCategory == 'AllProduct'?
							item:item.cateId==this.searchCategory
							// 依據選取類別篩選產品組
						})
						const conditions = this.searchText.split(' ')
							// 拆解關鍵字為條件數組
						const rslt = newArr.filter(i=>{
							
							const text = i[this.locales].toLowerCase()
							return conditions.map(el=>text.includes(el.toLowerCase())).every(bl=>bl)?
							i:false
							// 比對數組條件並回傳包含全部值的元素
						})
						return rslt
				}
			},
			cataBanner(){
				return this.categories.filter(item=>item.id==this.categoryNow)[0].name.bannerPath
			}
		},
		methods:{
			...mapActions('frontend',[
				'changeCategory'
				]),
			categorySwitch(name,id){
				const payload={name:name,id:id}
				this.changeCategory(payload)
			},
			goPage(page,query){
				// 頁面為產品及頁面為QA/Factory區別
				let Q = null
				switch (page) {
					case '/products':
					if(query.pop){
						Q = {path:page,query:{id:query.id,Popup:'product'}}
						this.categorySwitch(query.name,query.cateId)
					}else{
						Q = {path:page,query:{}}
					}
						break;
					default:
					Q = {path:page}
						break;
				}

				this.$router.push(Q)
			},
			getKeyword(val){
				this.searchText = val.length>0?val:null
			},
			searchSwitch(val){
				this.searchCategory = val
			},
			localStorageChange(boo){
				localStorage.sp_video = boo
			},
			closeVideo(){
				console.log('fuck2')
				this.Video_pop = false
				this.localStorageChange('YES')
			}
		}
	}
</script>
